import React, { FC } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
} from "@mui/material";

import { ReactComponent as ArrowDown } from "assets/icons/chevron-down.svg";
import { DrawerOptionsList } from "./drawer.styles";
import { useMenusData } from "../../../hooks/useMenusData";
import { useMenuLinkNavigation } from "../../../hooks/useMenuLinkNavigation";
import { buildNavStructure, NavEntry, NavLink } from "../navBar/navStructure";

interface DrawerProps {
  isOpen: boolean;
  onClose: any;
}

// Mesma estrutura da barra principal (menus fixos do APM ou a padrão) + "Acesso a Informações"
export const DrawerComponent: FC<DrawerProps> = ({ isOpen, onClose }) => {
  const openMenuLink = useMenuLinkNavigation();
  const { menus, mainMenus } = useMenusData();
  const navStructure = buildNavStructure(mainMenus);

  const handleNavigation = (path?: string, isExternal?: boolean) => {
    onClose();
    openMenuLink(path, isExternal);
  };

  const renderAccordion = (id: string, label: string, links: NavLink[]) => (
    <li key={id}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDown />}
          aria-controls={`drawer-${id}-content`}
          id={`drawer-${id}-header`}
        >
          {label}
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            {links.map((link) => (
              <li key={`${link.label}-${link.path}`} onClick={() => handleNavigation(link.path, link.isExternal)}>
                {link.label}
              </li>
            ))}
          </ul>
        </AccordionDetails>
      </Accordion>
    </li>
  );

  const renderEntry = (entry: NavEntry) => {
    if (!entry.children) {
      return (
        <li key={entry.id} onClick={() => handleNavigation(entry.path, entry.isExternal)}>
          {entry.label}
        </li>
      );
    }

    // Submenus em flyout (ex.: Gestão Fiscal) entram como itens da própria lista no mobile
    const links: NavLink[] = entry.children.flatMap((child) =>
      child.kind === "link"
        ? [child]
        : child.items.map((item) => ({ ...item, label: `${child.label} - ${item.label}` }))
    );

    return renderAccordion(entry.id, entry.label, links);
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <DrawerOptionsList>
        {navStructure.map(renderEntry)}
        {menus.map((menu) =>
          menu.url ? (
            <li key={`menu-${menu.id}`} onClick={() => handleNavigation(menu.url, menu.isExternal)}>
              {(menu.name || "").toUpperCase()}
            </li>
          ) : (
            renderAccordion(
              `menu-${menu.id}`,
              (menu.name || "").toUpperCase(),
              (menu.items || [])
                .filter((item) => !!item.url)
                .map((item) => ({ label: item.name || "", path: item.url!, isExternal: item.isExternal }))
            )
          )
        )}
        <li onClick={() => handleNavigation("/mapa-do-site")}>MAPA DO SITE</li>
      </DrawerOptionsList>
    </Drawer>
  );
};
